import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=5869361b&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=5869361b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869361b",
  null
  
)

export default component.exports